export function SetDocumentTitle(title: string) {
  document.title = `${title} - Strategy Unlocked`;
}
